var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrevMonth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0893 4.41107C13.4148 4.73651 13.4148 5.26414 13.0893 5.58958L8.67859 10.0003L13.0893 14.4111C13.4148 14.7365 13.4148 15.2641 13.0893 15.5896C12.7639 15.915 12.2363 15.915 11.9108 15.5896L6.91083 10.5896C6.58539 10.2641 6.58539 9.73651 6.91083 9.41107L11.9108 4.41107C12.2363 4.08563 12.7639 4.08563 13.0893 4.41107Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevMonth);
export default __webpack_public_path__ + "static/media/prevMonth.f880c619d30bd500fce92b30b9daaeb5.svg";
export { ForwardRef as ReactComponent };